import { render, staticRenderFns } from "./CalculatorProductView.vue?vue&type=template&id=67dd33d2&scoped=true"
import script from "./CalculatorProductView.vue?vue&type=script&lang=ts"
export * from "./CalculatorProductView.vue?vue&type=script&lang=ts"
import style0 from "./CalculatorProductView.vue?vue&type=style&index=0&id=67dd33d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd33d2",
  null
  
)

export default component.exports